import React from "react";
import { useLocation, LOCATIONS } from "./LocartionContext";

const LocationPopup = () => {
  const { showPopup, setLocation } = useLocation();

  if (!showPopup) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="location-popup-backdrop"
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 9999,
          backgroundColor: "rgba(0,0,0,0.82)",
          backdropFilter: "blur(3px)",
          WebkitBackdropFilter: "blur(3px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "1rem",
        }}
      >
        {/* Modal Card */}
        <div
          className="location-popup-card"
          style={{
            width: "100%",
            maxWidth: "440px",
            borderRadius: "16px",
            overflow: "hidden",
            border: "1.5px solid #bebebe",
            boxShadow: "0 8px 40px rgba(0,0,0,0.5)",
          }}
        >
          {/* Header — yellow brand strip */}
          <div
            className="location-popup-header text-center"
            style={{
              background: "#fcc234",
              padding: "1.8rem 1.5rem 1.4rem",
            }}
          >
            {/* Pin icon using pure CSS */}
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "52px",
                height: "52px",
                background: "rgba(0,0,0,0.12)",
                borderRadius: "50%",
                marginBottom: "0.75rem",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#000"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </div>

            <h2
              style={{
                fontFamily: "'kingthings_trypewriter_2Rg', serif",
                fontWeight: 800,
                fontSize: "clamp(1.2rem, 4vw, 1.6rem)",
                letterSpacing: "3px",
                textTransform: "uppercase",
                color: "#000",
                margin: 0,
                WebkitTextStroke: "0.5px",
              }}
            >
              Choose Your Location
            </h2>
            <p
              style={{
                fontFamily: "'kingthings_trypewriter_2Rg', serif",
                fontSize: "0.85rem",
                color: "#333",
                marginTop: "0.3rem",
                marginBottom: 0,
                letterSpacing: "1px",
              }}
            >
              Select your nearest Barleys outlet
            </p>
          </div>

          {/* Body — white, location buttons */}
          <div
            style={{
              background: "#fff",
              padding: "1.4rem",
              display: "flex",
              flexDirection: "column",
              gap: "0.75rem",
            }}
          >
            {Object.values(LOCATIONS).map((loc) => (
              <button
                key={loc.id}
                onClick={() => setLocation(loc.id)}
                className="location-option-btn"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1rem",
                  padding: "1rem 1.1rem",
                  border: "2px solid #e0e0e0",
                  borderRadius: "12px",
                  background: "#fff",
                  cursor: "pointer",
                  transition: "all 0.22s ease",
                  textAlign: "left",
                  width: "100%",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "#fcc234";
                  e.currentTarget.style.background = "#fffbee";
                  e.currentTarget.style.boxShadow =
                    "0 4px 14px rgba(252,194,52,0.2)";
                  e.currentTarget.querySelector(
                    ".pin-circle",
                  ).style.background = "#fcc234";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "#e0e0e0";
                  e.currentTarget.style.background = "#fff";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.querySelector(
                    ".pin-circle",
                  ).style.background = "#f5f0e8";
                }}
              >
                {/* Pin circle */}
                <div
                  className="pin-circle"
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "50%",
                    background: "#f5f0e8",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    transition: "background 0.22s ease",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#4e4a4a"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </div>

                {/* Text */}
                <div>
                  <p
                    style={{
                      fontFamily: "'kingthings_trypewriter_2Rg', serif",
                      fontWeight: 800,
                      fontSize: "1.05rem",
                      textTransform: "uppercase",
                      letterSpacing: "2px",
                      color: "#000",
                      margin: 0,
                      WebkitTextStroke: "0.4px",
                    }}
                  >
                    {loc.shortName}
                  </p>
                  <p
                    style={{
                      fontFamily: "'kingthings_trypewriter_2Rg', serif",
                      fontSize: "0.78rem",
                      color: "#888",
                      margin: 0,
                      letterSpacing: "0.5px",
                      marginTop: "2px",
                    }}
                  >
                    {loc.address}, {loc.city}
                  </p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default LocationPopup;
